import { useLocation, useNavigate } from 'react-router-dom'
import { NAV_ITEMS } from '../../app/routes'
import { useAppState } from '../../state/store'
import { useTheme } from '../../theme/ThemeProvider'
import { useAuth } from '../../auth/AuthProvider'

function currentTitle(pathname: string): string {
  const match = NAV_ITEMS.find((item) =>
    item.end ? pathname === item.path : pathname.startsWith(item.path),
  )
  return match?.label ?? 'AGOS'
}

function initials(email: string): string {
  return email.slice(0, 2).toUpperCase()
}

const ROLE_LABEL: Record<string, string> = {
  administrator: 'Administrador',
  analyst: 'Analista',
}

/** Encabezado: alterna sidebar, muestra título, tema, usuario y cierre de sesión. */
export function Header() {
  const { dispatch } = useAppState()
  const { theme, toggleTheme } = useTheme()
  const { user, logout } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await logout()
    navigate('/login', { replace: true })
  }

  return (
    <header className="header">
      <div className="header__left">
        <button
          type="button"
          className="icon-btn"
          aria-label="Alternar menú"
          onClick={() => dispatch({ type: 'TOGGLE_SIDEBAR' })}
        >
          ☰
        </button>
        <h1 className="header__title">{currentTitle(location.pathname)}</h1>
      </div>
      <div className="header__right">
        <button
          type="button"
          className="icon-btn"
          aria-label={theme === 'dark' ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'}
          onClick={toggleTheme}
        >
          {theme === 'dark' ? '☀' : '☾'}
        </button>
        {user && (
          <div className="header__user">
            <span className="header__avatar" aria-hidden="true">
              {initials(user.email)}
            </span>
            <span className="header__identity">
              <span className="header__email">{user.email}</span>
              <span className="header__role">{ROLE_LABEL[user.role] ?? user.role}</span>
            </span>
          </div>
        )}
        <button type="button" className="btn" onClick={handleLogout}>
          Salir
        </button>
      </div>
    </header>
  )
}
